const txteng14 = [
  ["Он поднялся с дивана", "He got up from the sofa"],
  ["Кот залез в коробку", "The cat got into the box"],
  ["Он скоро вернется", "He will get back soon"],
  ["Нам нужно перебраться через реку", "We need to get across the river"],
  ["Я редко выхожу на выходные", "I rarely get out on weekends"],
  ["Он попал в дом через окно", "He got into the house through the window"],
  [
    "Как мне добраться до центра занятости?",
    "How can I get to the job center?",
  ],
  ["Я хочу вернуть свои деньги", "I want to get my money back"],
  ["Мы выходим на следующей остановке", "We are getting off at the next stop"],
  [
    "Я вылез из окна, а затем мы перелезли через забор",
    "I got out of the window and then we got over the fenc (горовер)",
  ],
  ["Мы прошли через многое", "We got through a lot"],
  ["Убирайся отсюда", "Get out of here"],
  ["У меня неприятности", "I got into troubles"],
  ["Они спустились в метро", "They got down into the Subway"],
  ["Мы можем подняться на крышу", "We can get up to the roof"],
  [
    "Нам нужно выбираться и придумать как спуститься",
    "We need to get out and figure out how to get down",
  ],
  ["Она пробирается сквозь толпу", "She is getting through the crowd"],
  ["Он сбежал рано утром", "He got away early in the morning"],
  ["Я хочу вернуться к работе", "I want to get back to work"],
  [
    "Он сошел с поезда и затем сел на автобус",
    "He got off the train and then he got on the bus",
  ],
  ["Я не могу выбраться отсюда", "I can't get out of here"],
  [
    "Они вернулись из Дании 2 недели назад",
    "They got back from Denmark two weeks ago",
  ],
  [
    "Он сел в машину, но потом быстро вышел из нее",
    "He got into the car but then he got out of it",
  ],
];

export default txteng14;
